import React from 'react'

const Gallery = () => {
  const images = [
    {
      id: 1,
      src: "https://saed.sn/static/assets/images/services/service-1-3.png",
      alt: "Production rizicole SAED - Casiers aménagés"
    },
    {
      id: 2,
      src: "https://saed.sn/static/assets/images/services/service-2-6.png",
      alt: "Aménagements hydro-agricoles dans le delta"
    },
    {
      id: 3,
      src: "https://saed.sn/static/assets/images/services/service-2-5.png",
      alt: "Agriculture familiale appuyée par la SAED"
    },
    {
      id: 4,
      src: "https://saed.sn/static/assets/images/projects/project-2-6.png",
      alt: "Projets de développement SAED"
    },
    {
      id: 5,
      src: "https://saed.sn/static/assets/images/resources/about-1-1.png",
      alt: "Plan stratégique de développement SAED"
    },
    {
      id: 6,
      src: "https://images.unsplash.com/photo-1500595046743-cd271d694d30?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      alt: "Élevage de zébus Gobra au Sénégal - Touba"
    },
    {
      id: 7,
      src: "https://images.unsplash.com/photo-1574323347407-f5e1ad6d020b?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      alt: "Casier rizicole de Bow - Récolte campagne sèche chaude"
    },
    {
      id: 8,
      src: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      alt: "Agro-pastoralisme et résilience climatique"
    },
    {
      id: 9,
      src: "https://images.unsplash.com/photo-1565689850620-d3e88040e87d?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      alt: "Système d'irrigation moderne - Projet 3PRD"
    },
    {
      id: 10,
      src: "https://images.unsplash.com/photo-1586519520430-bb6e8e9c9eef?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      alt: "Formation technique avec la SAED"
    },
    {
      id: 11,
      src: "https://images.unsplash.com/photo-1625246333195-78d9c38ad449?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      alt: "Amélioration génétique de l'élevage"
    },
    {
      id: 12,
      src: "https://images.unsplash.com/photo-1498579397066-22750a3cb424?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      alt: "Coopératives et GIE de la vallée du fleuve"
    }
  ]

  return (
    <div className="Gallery">
      <section className="relative py-24 bg-gradient-to-r from-primary-600 to-accent-600">
        <div className="container-custom">
          <div className="text-center text-white">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              Galerie
            </h1>
            <p className="text-xl opacity-90 max-w-3xl mx-auto">
              Découvrez nos activités agricoles et d'élevage dans la vallée du fleuve Sénégal, 
              avec les vraies images des projets SAED et de l'élevage sénégalais
            </p>
          </div>
        </div>
      </section>

      <section className="section-padding">
        <div className="container-custom">
          <div className="mb-12 text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Agriculture et Élevage authentiques du Sénégal
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              En partenariat avec la SAED et les organismes de développement, découvrez les vraies réalisations 
              d'agriculture et d'élevage dans le delta et la vallée du fleuve Sénégal. 
              L'élevage contribue à plus de 3% du PIB national.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {images.map((image) => (
              <div key={image.id} className="card overflow-hidden group cursor-pointer">
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="p-4">
                  <p className="text-sm text-gray-600 text-center font-medium">{image.alt}</p>
                </div>
              </div>
            ))}
          </div>
          
          <div className="mt-12 grid md:grid-cols-2 gap-8">
            <div className="bg-green-50 rounded-xl p-8">
              <div className="text-center">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  Partenariat SAED
                </h3>
                <p className="text-gray-600 mb-4">
                  Notre coopérative travaille en étroite collaboration avec la SAED 
                  pour développer une agriculture moderne et durable dans la région de Saint-Louis.
                </p>
                <a 
                  href="https://saed.sn" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-primary-600 hover:text-primary-700 font-medium"
                >
                  Visiter le site officiel SAED →
                </a>
              </div>
            </div>
            
            <div className="bg-orange-50 rounded-xl p-8">
              <div className="text-center">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  Élevage Sénégalais
                </h3>
                <p className="text-gray-600 mb-4">
                  L'élevage contribue à plus de 3% du PIB national. Plus de 44% des ménages 
                  sénégalais sont engagés dans l'agriculture et l'élevage.
                </p>
                <div className="text-sm text-gray-500">
                  Sources: 
                  <a href="https://www.afrique-agriculture.org" className="text-primary-600 hover:underline ml-1">
                    Afrique Agriculture
                  </a>
                  , 
                  <a href="https://financesao.com" className="text-primary-600 hover:underline ml-1">
                    FinanceAO
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Gallery 